/**
 * Non-copy constants for the /lighthouse/naic-checklist funnel. Copy lives in
 * the i18n catalog under `lighthouse.checklist`.
 */

export const NAIC_CHECKLIST_ROUTE = '/lighthouse/naic-checklist';
export const NAIC_CHECKLIST_PDF_PATH = '/resources/NAIC_AI_Readiness_Checklist.pdf';
export const NAIC_CHECKLIST_CANONICAL = `https://www.criticalbridge.ai${NAIC_CHECKLIST_ROUTE}`;

export const NAIC_CHECKLIST_ROLES = ['cco', 'cio', 'cdo', 'ai', 'other'] as const;
export const NAIC_CHECKLIST_WHAT_YOU_GET = ['pages', 'cites', 'neutral'] as const;
export const NAIC_CHECKLIST_STATS = ['adopted', 'ownRules', 'scope'] as const;

/** Links out of the checklist funnel, tagged so briefings that start here are visible. */
export const naicChecklistLinks = {
  briefingFromLanding: '/contact?utm_source=checklist&utm_medium=landing',
  lighthouseFromLanding: '/lighthouse?utm_source=checklist&utm_medium=landing#compliance',
  checklistFromLighthouse: `${NAIC_CHECKLIST_ROUTE}?utm_source=lighthouse-page&utm_medium=web`,
} as const;
